import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div>
            <h1 className='error-code'>404</h1>
            <h5>The webpage you're looking for is not found.</h5>
        </div>
    );
};

export default NotFound;